import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import QuoteForm from "@components/forms/QuoteForm";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import AddClientOffCanvas from "@components/layout/Offcanvas/AddClientOffCanvas";
import DocumentOtherChargesOffCanvas from "@components/layout/Offcanvas/DocumentOtherChargesOffCanvas";
import ShippingCostOffCanvas from "@components/layout/Offcanvas/ShippingCostOffCanvas";
import { ClientDataType } from "@/api/ClientApi";
import { AddClientToDocumentPubSub, LoadInvoiceTemplatePubSub, OpenDocumentExemptionPubSub, OpenDocumentOtherChargesPubSub, OpenShippingCostPubSub } from "@utils/pubsubs/PubSub";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { clearAllProductsExemptionData, clearDefaultExemption } from "@/store/slices/eDocumentSlides";
import { InvoiceTemplateDataType } from "@/api/InvoiceTemplateApi";
import { selectDocumentSummary } from "@/store/slices/utils/eDocumentSelectors";

type QuoteAddEditProps = {
  copyData?: boolean
}

const QuoteAddEdit = (props: QuoteAddEditProps) => {
  const { copyData = false } = props
  const documentSummary = useAppSelector(selectDocumentSummary);
  const dispatch = useAppDispatch()
  const defaultExemption = useAppSelector((state) => state.eDocument.defaultExemption)
  const documentOtherCharges = useAppSelector((state) => state.eDocument.documentOtherCharges)
  const params = useParams()
  const { id: copyQuoteId } = params;

  useEffect(() => {
  }, []);

  const onClientStored = (clientData?: ClientDataType) => {
    if (clientData) {
      AddClientToDocumentPubSub.publish({ client: clientData })
    }
  }

  const onTemplateSelect = (invoiceTemplate: InvoiceTemplateDataType) => {
    LoadInvoiceTemplatePubSub.publish({ invoiceTemplate })
  }

  const getPageTitle = () => {
    if (!copyData && copyQuoteId) {
      return "Modificar Cotizacion"
    }
    return "Agregar Cotizacion"
  }

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={getPageTitle()}
      backUrl="/user/quotes"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "quoteAdd",
          type: "submit",
          color: "success"
        },
        {
          customElement: (
            <AddProductToDocumentOffCanvas
              onTemplateSelect={onTemplateSelect}
              btnColor="success">
              Agregar Producto
            </AddProductToDocumentOffCanvas>
          )
        }
      ]}
      secondaryActions={[
        {
          actionTitle: `${defaultExemption ? "Editar" : "Agregar"} Exoneracion a Documento`,
          onClick: () => {
            if (defaultExemption) {
              OpenDocumentExemptionPubSub.publish({
                openOffCanvas: true,
                defaultData: defaultExemption,
                lineSubtotal: defaultExemption.lineSubtotal || 0
              })
            } else {
              OpenDocumentExemptionPubSub.publish({
                openOffCanvas: true,
                defaultData: { monto_impuesto: documentSummary.impuestos, porcentaje_compra: "13" },
                lineSubtotal: documentSummary.subtotal
              })
            }
          }
        },
        {
          isVisible: !!defaultExemption,
          actionTitle: `Eliminar Exoneracion`,
          onClick: () => {
            dispatch(clearAllProductsExemptionData())
            dispatch(clearDefaultExemption())
          }
        },
        {
          actionTitle: `Otros Cargos (${documentOtherCharges.length})`,
          onClick: () => {
            OpenDocumentOtherChargesPubSub.publish({ openOffCanvas: true, documentKind: "Quote" })
          }
        },
        {
          actionTitle: "Agregar Costo de Envio",
          onClick: () => {
            OpenShippingCostPubSub.publish({ openOffCanvas: true, documentKind: "Quote" })
          }
        },
      ]}
    >
      <QuoteForm
        id={copyQuoteId}
        copyData={copyData}
        saveRedirectUrl="/user/quotes"
        formId="quoteAdd" >
      </QuoteForm>

      <AddClientOffCanvas
        onStored={onClientStored} />

      <DocumentOtherChargesOffCanvas />

      <ShippingCostOffCanvas />

    </PageContainer>
  );
}

export default QuoteAddEdit;
